import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const ClickButtonIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				d="M1 3.25C1 2.00736 2.00736 1 3.25 1H12.75C13.9926 1 15 2.00736 15 3.25V5.75C15 6.50713 14.626 7.17692 14.0527 7.58473C13.9484 7.45926 13.8256 7.34379 13.6842 7.24186L7.62627 2.87427C6.27009 1.89651 4.32816 2.95255 4.51218 4.67664L4.86688 8H3.25C2.00736 8 1 6.99264 1 5.75V3.25Z"
			></path>
			<path
				fill="currentColor"
				d="M12.8061 8.45806L6.74814 4.09047C6.41819 3.85259 5.95989 4.11479 6.00281 4.5169L6.79077 11.8996C6.82662 12.2354 7.1994 12.4235 7.49452 12.2547L9.32536 11.234L11.6197 14.824C11.7649 15.0047 12.0217 15.0529 12.2235 14.9375L12.7446 14.6393C12.9465 14.5239 13.0327 14.2794 12.9474 14.0644L10.9571 10.3004L12.7645 9.23954C13.0597 9.07069 13.0817 8.65673 12.8061 8.45806Z"
			></path>
		</svg>
	),
)
